import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import CookieConsent from "@/components/CookieConsent";
import ErrorBoundary from "@/components/ErrorBoundary";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Vehicles from "@/pages/Vehicles";
import VehicleDetail from "@/pages/VehicleDetail";
import Maintenance from "@/pages/Maintenance";
import CalendarPage from "@/pages/CalendarPage";
import Budget from "@/pages/Budget";
import Profile from "@/pages/Profile";
import SharedLogbook from "@/pages/SharedLogbook";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center text-slate-500">Chargement…</div>;
  if (user === false) return <Navigate to="/connexion" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <AnalyticsTracker />
      <CookieConsent />
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/connexion" element={<Login />} />
          <Route path="/inscription" element={<Register />} />
          <Route path="/partage/:token" element={<SharedLogbook />} />
          <Route path="/app" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="vehicules" element={<Vehicles />} />
            <Route path="vehicules/:id" element={<VehicleDetail />} />
            <Route path="entretien" element={<Maintenance />} />
            <Route path="calendrier" element={<CalendarPage />} />
            <Route path="budget" element={<Budget />} />
            <Route path="profil" element={<Profile />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
